import React from 'react'
import { EsaIncident } from '../lib/models'
import styled from 'styled-components'

const KeySpan = styled.span`
  font-weight: bold;
  text-transform: capitalize;
`

const Title = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
`

// const renderKey = (incident: EsaIncident, key: keyof EsaIncident) => {
//   if (!incident[key]) return <></>
//   console.log('renderKey', incident.id, key);
//   return (
//     <div key={incident.id + ":" + key} className="item">
//       <KeySpan>{key.replace('_', ' ')}</KeySpan> : {incident[key]}
//     </div>
//   )
// }

// const renderKeys = (incident: EsaIncident, keys: (keyof EsaIncident)[]) => {
//   return (
//     <div className="ui list">{keys.filter(key => incident.hasOwnProperty(key)).map(key => renderKey(incident, key))}</div>
//   )
// }

const EsaIncidentInfoComponent = (props: { incident: EsaIncident }) => (
  <div>
    {props.incident.alert_level && (
      <div>
        <span className="ui label">{props.incident.alert_level}</span>
      </div>
    )}
    <Title>{props.incident.title}</Title>
    <div>{props.incident.time_of_call}</div>
    <div className="ui list">
      {props.incident.hasOwnProperty('location') && 
        <div className="item">
          <KeySpan>location</KeySpan> : {props.incident.location}
        </div>
      }
      {props.incident.hasOwnProperty('status') && 
        <div className="item">
          <KeySpan>status</KeySpan> : {props.incident.status}
        </div>
      }
      {props.incident.hasOwnProperty('type') && 
        <div className="item">
          <KeySpan>type</KeySpan> : {props.incident.type}
        </div>
      }
      {props.incident.hasOwnProperty('updated') && 
        <div className="item">
          <KeySpan>updated</KeySpan> : {props.incident.updated}
        </div>
      }
      {props.incident.hasOwnProperty('agency') && 
        <div className="item">
          <KeySpan>agency</KeySpan> : {props.incident.agency}
        </div>
      }
      {props.incident.hasOwnProperty('alert_level') && 
        <div className="item">
          <KeySpan>alert level</KeySpan> : {props.incident.alert_level}
        </div>
      }
      {props.incident.hasOwnProperty('alert_status') && 
        <div className="item">
          <KeySpan>alert status</KeySpan> : {props.incident.alert_status}
        </div>
      }
      {props.incident.hasOwnProperty('alert_time') && 
        <div className="item">
          <KeySpan>alert time</KeySpan> : {props.incident.alert_time}
        </div>
      }
    </div>
    {/* {renderKeys(props.incident, [
      'location',
      'status',
      'type',
      'updated',
      'agency',
      'alert_level',
      'alert_status',
      'alert_time'
    ])} */}
    {props.incident.node && (
      <a target="_blank" rel="noopener noreferrer" href={props.incident.node}>
        View Alert
      </a>
    )}{' '}
    {props.incident.link_text && (
      <a target="_blank" rel="noopener noreferrer" href={props.incident.link}>
        {props.incident.link_text}
      </a>
    )}
  </div>
)

export default EsaIncidentInfoComponent
